export default __webpack_public_path__ + "static/day-10-a0da6b298f23a458dbd21f120b21376f.gif";